<section class="panel" [class.hide-header]="!hasTitle">
  @if (hasTitle) {
    <div class="panel-heading">
      <h3 class="panel-title">
        {{title}}
      </h3>
    </div>
  }

  <div class="panel-body">
    <ng-content></ng-content>
  </div>
</section>
